import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getVendors } from '@api/manageSite';

import { extractQueryParams } from '@utils/common';
import { optionsFormatted } from '@utils/formatter';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { VENDORS } from '@constants/queryKeys';

export function useQuerySiteVendors() {
	const {
		accessPermission: {
			networkOperatorTelecomSitesViewer,
			networkOperatorTelecomSitesAttributeUpdater,
			networkOperatorKpiViewer,
			networkOperatorKpiUpdater,
			networkOperatorOrganizationAdministrator,
		},
	} = useAppSelector(auth);

	const isVendorsAvailable = (
		networkOperatorTelecomSitesViewer ||
		networkOperatorTelecomSitesAttributeUpdater ||
		networkOperatorKpiViewer ||
		networkOperatorKpiUpdater ||
		networkOperatorOrganizationAdministrator
	);

	const { data: vendors, isFetching } = useQuery({
		queryKey: [VENDORS],
		queryFn: extractQueryParams(getVendors),
		allowedRoles: [
			EUserRoles.networkOperatorTelecomSitesViewer,
			EUserRoles.networkOperatorTelecomSitesAttributeUpdater,
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
			EUserRoles.networkOperatorOrganizationAdministrator,
		],
		enabled: [isVendorsAvailable],
		...refetchOptions,
	});

	return {
		vendors: vendors || [],
		isLoading: isFetching,
		vendorsOptions: optionsFormatted(vendors || []),
	};
}
